module.exports = __webpack_public_path__ + "assets/media/global.e74270da.mp3";